import React, { useContext } from 'react';
import { func, shape } from 'prop-types';
import { MDialog } from 'common';
import { AuthContext } from 'authentication/AuthContext';
import { Typography } from '@mui/material';

const SupplierAuthDialog = ({ confirmCloseDialog, setDialogDetails, dialogDetails }) => {
  const { currentAffiliate } = useContext(AuthContext);

  const { cancelAction, confirmAction, header, message, params } = dialogDetails ?? {};

  const handleCancel = () => {
    if (cancelAction) {
      cancelAction();
    }
    setDialogDetails();
  };

  const handleConfirm = () => {
    if (!confirmAction) {
      confirmCloseDialog();
      return setDialogDetails();
    }
    confirmAction(params, currentAffiliate);
    return setDialogDetails();
  };

  return (
    <MDialog
      header={header}
      leftButtonAction={handleCancel}
      leftButtonText="Back"
      onClose={handleCancel}
      open={!!message}
      rightButtonAction={handleConfirm}
      rightButtonText="Confirm"
      sx={{
        '& .MuiDialogContent-root': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Typography color="textPrimary" component="span" variant="body1">
        {message}
      </Typography>
    </MDialog>
  );
};

export default SupplierAuthDialog;

SupplierAuthDialog.propTypes = {
  confirmCloseDialog: func.isRequired,
  dialogDetails: shape({}).isRequired,
  setDialogDetails: func.isRequired,
};
